var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEncendidoSinPruebaDeAlcohol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.01 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4414db;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-encendido-sin-prueba-de-alcohol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_15",
    "data-name": "38 copia 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8,0V13H50.59V24.52H25.24a25.25,25.25,0,0,0,0,50.49H50.59V86.56H74.8v9.26H88V13.17H209.84V222.4H154.4v13.17H223V0ZM25.24,61.83a12.07,12.07,0,1,1,0-24.13H50.59V61.83ZM63.77,73.39V26.14h11V73.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,31h-87v74.62h87ZM178.23,92.42H117.58V44.15h60.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.39,255.12a71.76,71.76,0,1,1,71.76-71.76A71.84,71.84,0,0,1,81.39,255.12Zm0-130.35A58.59,58.59,0,1,0,140,183.36,58.65,58.65,0,0,0,81.39,124.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.7,183.36l22.53-22.53a6.59,6.59,0,0,0-9.31-9.32L81.39,174,58.86,151.51a6.59,6.59,0,0,0-9.32,9.32l22.53,22.53L49.54,205.89a6.59,6.59,0,0,0,9.32,9.31l22.53-22.53,22.53,22.53a6.58,6.58,0,0,0,9.31-9.31Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEncendidoSinPruebaDeAlcohol);
export default __webpack_public_path__ + "static/media/ic-encendido-sin-prueba-de-alcohol.b0c0ea6f8073ed82c818111b67a902d0.svg";
export { ForwardRef as ReactComponent };